import React, { useRef, useState } from 'react';
import GQPopup from '../components/GQPopups/GQPopup';

/**
 * Confirmation before deleting a saved view, matching the advanced-filter delete
 * popup. Only reached for views that can actually be deleted: a view an alert
 * depends on is refused before this opens, so the user is never asked to confirm
 * something that will then be refused.
 *
 * Deleting cannot be undone, and when the view is shared it also takes it off the
 * recipients' sidebars - called out here rather than discovered afterwards.
 */
const DiscoverViewDeleteModal = (props) => {
    const viewName = props.viewName || '';
    // The delete is a round trip, so hold the dialog open until it lands: closing first
    // left the failure message landing over a sidebar that had already moved on, and let
    // a second Delete start while the first was still in flight.
    const [deleting, setDeleting] = useState(false);
    // Cancel stays live while the delete runs - a request that never settles must not
    // trap the user in a dialog. Once they have dismissed it, the request finishes
    // quietly: closing again here would shut whichever dialog is open by then.
    const dismissed = useRef(false);

    const dismiss = () => {
        dismissed.current = true;
        props.closeModal();
    }

    const confirmDelete = async () => {
        if (deleting) {
            return;
        }
        setDeleting(true);
        try {
            // deleteViewAction reports its own failures to the user; catch here so a
            // throw past its own handling is logged rather than becoming a bare
            // unhandled rejection.
            await props.deleteViewAction(viewName);
        } catch (err) {
            console.log('delete view failed', err);
        }
        if (dismissed.current) {
            return;
        }
        setDeleting(false);
        props.closeModal();
    }

    return (
        <GQPopup
            show={props.showModal}
            close={dismiss}
            innerHtml={
                <div style={{ width: '400px' }}>
                    <h4 style={{ marginBottom: '12px' }}>Delete</h4>
                    {/* View names can be one long unbroken token; wrap it inside the box. */}
                    <p style={{ marginBottom: props.isShared ? '8px' : '16px', overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
                        {'Are you sure you want to delete "' + viewName + '"?'}
                    </p>
                    {props.isShared &&
                        <p style={{ marginBottom: '16px' }}>
                            You have shared this view. Deleting it also removes it from the
                            Shared Views list of everyone you shared it with.
                        </p>
                    }
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <button className='small-button cancelButtonClass' onClick={dismiss}>Cancel</button>
                        <button className='small-button submitButtonClass' onClick={confirmDelete} disabled={deleting}>{deleting ? 'Deleting...' : 'Delete'}</button>
                    </div>
                </div>
            }
        />
    );
}
export default DiscoverViewDeleteModal;
